class ProductOptionSelectors {
  constructor(selectId, options) {
    this.product = options.product || {};
    this.onVariantSelected = typeof options.onVariantSelected === 'function' ? options.onVariantSelected : function () {};
    this.historyEnabled = Boolean(options.enableHistoryState);
    this.variantIdField = document.getElementById(selectId);
    this.selectors = [];
    if (!this.variantIdField) return;
    this.buildSelectors(selectId);
    this.initDropdown();
    if (this.historyEnabled) {
      this.teardown = new AbortController();
      window.addEventListener('popstate', () => this.selectVariantFromParamsOrDropdown({ popStateCall: true }), {
        signal: this.teardown.signal,
      });
      // Theme editor re-renders the section: drop this instance's listeners so the stale
      // copy stops resolving variants against detached nodes.
      const section = this.variantIdField.closest('.shopify-section');
      if (section) {
        document.addEventListener(
          'shopify:section:unload',
          (event) => {
            if (event.detail && `shopify-section-${event.detail.sectionId}` === section.id) this.teardown.abort();
          },
          { signal: this.teardown.signal }
        );
      }
    }
  }

  optionNames() {
    return Array.isArray(this.product.options) ? this.product.options : [];
  }

  optionValues(index) {
    const key = `option${index + 1}`;
    const values = (this.product.variants || []).map((variant) => (variant[key] == null ? null : variant[key]));
    if (!values.length || values[0] == null) return [];
    return [...new Set(values)];
  }

  buildSelectors(selectId) {
    const names = this.optionNames();
    const parent = this.variantIdField.parentNode;

    parent.querySelectorAll(':scope > .selector-wrapper').forEach((wrapper) => wrapper.remove());
    this.selectors = [];

    names.forEach((name, index) => {
      const select = document.createElement('select');
      this.optionValues(index).forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
      select.className = 'single-option-selector';
      select.setAttribute('data-option', `option${index + 1}`);
      select.id = `${selectId}-option-${index}`;
      // DOM0 handler on purpose: jQuery .trigger('change', options) passes its extra argument only here.
      select.onchange = (event, changeOptions) => this.updateSelectors(index, changeOptions || {});

      const wrapper = document.createElement('div');
      wrapper.className = 'selector-wrapper';
      if (names.length > 1) {
        const label = document.createElement('label');
        label.htmlFor = select.id;
        label.textContent = name;
        wrapper.appendChild(label);
      }
      wrapper.appendChild(select);
      parent.insertBefore(wrapper, this.variantIdField);
      this.selectors.push({ element: select, name, index });
    });

    this.variantIdField.style.display = 'none';
  }

  initDropdown() {
    const options = { initialLoad: true };
    if (this.selectVariantFromDropdown(options)) return;
    setTimeout(() => {
      if (!this.selectVariantFromParams(options)) this.updateSelectors(0, {});
    });
  }

  selectVariantFromDropdown(options) {
    const selected = this.variantIdField.querySelector('[selected]');
    if (!selected) return false;
    return this.selectVariant(selected.value, options);
  }

  selectVariantFromParams(options) {
    return this.selectVariant(this.urlParam('variant'), options);
  }

  selectVariantFromParamsOrDropdown(options) {
    if (!this.selectVariantFromParams(options)) this.selectVariantFromDropdown(options);
  }

  selectVariant(variantId, options) {
    const variant = this.getVariantById(variantId);
    if (!variant) return false;

    this.selectors.forEach(({ element }) => {
      const value = variant[element.getAttribute('data-option')];
      if (value == null || !this.optionExistInSelect(element, value)) return;
      element.value = value;
    });

    const first = this.selectors[0];
    if (!first) return false;
    if (window.jQuery) {
      window.jQuery(first.element).trigger('change', options);
    } else {
      first.element.onchange(new Event('change'), options);
    }
    return true;
  }

  optionExistInSelect(select, value) {
    return Array.from(select.options).some((option) => option.value === String(value));
  }

  selectedValues() {
    return this.selectors.map(({ element }) => element.value);
  }

  updateSelectors(index, options) {
    const variant = this.getVariant(this.selectedValues());
    if (variant) {
      this.variantIdField.disabled = false;
      this.variantIdField.value = variant.id;
    } else {
      this.variantIdField.disabled = true;
    }
    this.onVariantSelected(variant, this, options);
    if (this.historyEnabled && variant && !options.initialLoad && !options.popStateCall) {
      this.setParam('variant', variant.id);
    }
  }

  getVariant(selectedValues) {
    if (selectedValues.length !== this.optionNames().length) return null;
    return (this.product.variants || []).find((variant) =>
      selectedValues.every((value, j) => String(variant[`option${j + 1}`]) === String(value))
    ) || null;
  }

  getVariantById(id) {
    if (id == null) return null;
    return (this.product.variants || []).find((variant) => String(variant.id) === String(id)) || null;
  }

  urlParam(name) {
    const match = new RegExp(`[?&]${name}=([^&#]*)`).exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  setParam(key, value) {
    const search = window.location.search;
    let newSearch;
    if (this.urlParam(key)) {
      newSearch = search.replace(new RegExp(`([?&]${key}=)[^&#]+`), `$1${value}`);
    } else if (search === '') {
      newSearch = `?${key}=${value}`;
    } else {
      newSearch = `${search}&${key}=${value}`;
    }
    window.history.replaceState({}, document.title, newSearch + window.location.hash);
  }
}

window.ProductOptionSelectors = ProductOptionSelectors;
